import React from 'react';
import { last, get } from 'lodash';
import { any, string } from 'prop-types';
import { OrderEventsFeedConsumer } from '../../../../components/firebase/OrderEventsFeed';
import { withReloadable } from '../../../../hoc';

const OrderStatus = ({ children }) => (
    <OrderEventsFeedConsumer>
        {({ events }) => {
            return children({
                ts: get(last(events), 'ts', new Date().toISOString())
            });
        }}
    </OrderEventsFeedConsumer>
);

OrderStatus.propTypes = {
    children: any
};

OrderStatus.defaultProps = {
    session: null,
    orderId: string.isRequired
};

export default withReloadable(OrderStatus, ['orderId']);
